import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Settings,
  SettingsContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-settings',
  template: Settings.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Settings.height;
  @Input() public viewBox: string = getSVGViewBox(Settings.viewBox);
  @Input() public width: number | string = Settings.width;
  @Input()
  public set context(ctx: SettingsContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: SettingsContext = Settings.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = SettingsComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Settings.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
